export const orders_extensions = {
    methods: {
        refreshCart: function () {
            var _self = this;
            var data = {
                FranchiseID: localStorage.franchiseID,
                Guid: localStorage.cartGuid
            }
            this.$ooApi.orders.cart.refresh.v1(data).then(function (response) {
                getCartMenuPartial(_self, response.data)
            })
            // check .catch
        },
        logoutUser: function () {
            var _self = this;
            var data = {
                FranchiseID: localStorage.franchiseID,
                Token: localStorage.userToken
            }
            _self.$ooApi.orders.accounts.logout.v1(data).then(function () {
                _self.$isLoggedIn = false;
                _self.$UserMembershipID = null;
                _self.$UserToken = null;
                _self.$OrdersUserToken = null;
                _self.$OrdersUserRefreshToken = null;
                _self.$router.push('Login');
            })
        },
        clearStorage: function () {
            localStorage.clear();
        }
    }
}

function getCartMenuPartial(_self, data) {
    _self.$root.$children[0].$children.forEach(element => {
        if (element.$el.classList?.contains('topnav')) {
            element.$refs.cartMenuPartial.populate(data);
        }
    });
}